__turbopack_context__.v({
  "link": "dTJ0Jq_link",
});
